import { useStore } from '../state/ui-store';
import { displayXrayView } from './display-xray-view';
import { pauseGoviePlayback } from './pause-govie-playback';
import { stopExplosionBeforeContinue } from './stop-explosion-before-continue';
import { turnOffPower } from './turn-off-power';
import { turnOnPower } from './turn-on-power';

export const onPowerIconClick = async () => {
  const { powerBttnActive } = useStore.getState();
  const newState = !powerBttnActive;

  if (newState) {
    await stopExplosionBeforeContinue();
    displayXrayView();
    turnOnPower();
  } else {
    turnOffPower();
  }

  pauseGoviePlayback();
};
